module.exports = __webpack_public_path__ + "img/维修中.17d34f94.png";